import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Classes from "./DropDown.module.css";

export default function DropDown({
  selectedValue,
  options = [],
  onChange,
  isDropDown = true,
}) {
  const [dropDown, setDropDown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  console.log(selectedValue);


  return (
    <div ref={dropdownRef} className={Classes.dropDown}>
      {/* Dropdown Head */}
      <div
        className={`${Classes.dropDownHead} ${selectedValue === "Submitted" ? Classes.submitted : selectedValue === "Working" || selectedValue === "In progress" ? Classes.working : ''}`}
        onClick={() => isDropDown && setDropDown(!dropDown)}
        style={{
          cursor: isDropDown ? "pointer" : "default",
        }}
      >
        <p style={{ textTransform: "capitalize" }}>
          {selectedValue ? selectedValue : "Select"}
        </p>
        {isDropDown && (
          <svg
            height='10px'
            fill={selectedValue === "Submitted" ? '#008c4b' : selectedValue === "Working" || selectedValue === "In progress" ? '#0052ff' : selectedValue === "Pending" ? '#cdd000' :
              selectedValue === "Completed" ? '#f4c20d' : selectedValue === "Canceled" ? '#ff0000' : `#000000`
            }
            style={{ transform: dropDown ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s ease" }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
          </svg>
        )}
      </div>

      {/* Dropdown Body */}
      <AnimatePresence>
        {dropDown && isDropDown && (
          <motion.div
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.15 }}
            className={Classes.dropDownBody}
          >
            <div className={Classes.ddPointerCon}>
              <div className={Classes.dropDownPointer}></div>
            </div>
            <div className={Classes.dropDownBodyInner}>
              {options.map((option, index) => (
                <div key={index}>
                  <div
                    className={`${Classes.dropDownElem} ${selectedValue === option ? Classes.activeDropElem : ""
                      }`}
                    onClick={() => {
                      onChange(option);
                      setDropDown(false);
                    }}
                    style={{ padding: "5px 10px" }}
                  >
                    <h5>{option}</h5>
                  </div>
                  {index < options.length - 1 && <div className={Classes.dropDownLine}></div>}
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Hidden input for form control */}
      <input type="hidden" value={selectedValue} readOnly />
    </div>
  );
}
